export default __webpack_public_path__ + "static/media/SWL.a95f9b69.png";